"use strict";
export function titleToSlug(title) {
  if (typeof title !== "string" || !title.trim()) return "";
  const trimmed = title.trim();
  const normalized = trimmed.normalize("NFD");
  const ascii = normalized.replace(/\p{M}/gu, "");
  const withHyphens = ascii.replace(/\s+/g, "-");
  const safe = withHyphens.replace(/[^a-zA-Z0-9-]/g, "");
  const collapsed = safe.replace(/-+/g, "-").replace(/^-|-$/g, "");
  return collapsed.toLowerCase();
}
